import { render, staticRenderFns } from "./CompaniesReportListPage.vue?vue&type=template&id=0549d464&scoped=true"
import script from "./CompaniesReportListPage.vue?vue&type=script&lang=js"
export * from "./CompaniesReportListPage.vue?vue&type=script&lang=js"
import style0 from "./CompaniesReportListPage.vue?vue&type=style&index=0&id=0549d464&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0549d464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0549d464')) {
      api.createRecord('0549d464', component.options)
    } else {
      api.reload('0549d464', component.options)
    }
    module.hot.accept("./CompaniesReportListPage.vue?vue&type=template&id=0549d464&scoped=true", function () {
      api.rerender('0549d464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/CompaniesReportListPage.vue"
export default component.exports